import firebase from "firebase";
import { OlabUtils } from "./olabutils.js";

class OlabGene {
  constructor(gene) {
    if (gene == null) {
      this.initGene();
    } else {
      let hp = Object.prototype.hasOwnProperty;
      this.olab_id = hp.call(gene, "olab_id") ? gene.olab_id : null;
      this.name = hp.call(gene, "name") ? gene.name : null;
      this.name_uc = hp.call(gene, "name_uc") ? gene.name_uc : null;
      this.synonym_name1 = hp.call(gene, "synonym_name1")
        ? gene.synonym_name1
        : null;
      this.synonym_name1_uc = hp.call(gene, "synonym_name1_uc")
        ? gene.synonym_name1_uc
        : null;
      this.synonym_name2 = hp.call(gene, "synonym_name2")
        ? gene.synonym_name2
        : null;
      this.synonym_name2_uc = hp.call(gene, "synonym_name2_uc")
        ? gene.synonym_name2_uc
        : null;
      this.synonym_name3 = hp.call(gene, "synonym_name3")
        ? gene.synonym_name3
        : null;
      this.synonym_name3_uc = hp.call(gene, "synonym_name3_uc")
        ? gene.synonym_name3_uc
        : null;
      this.synonym_name4 = hp.call(gene, "synonym_name4")
        ? gene.synonym_name4
        : null;
      this.synonym_name4_uc = hp.call(gene, "synonym_name4_uc")
        ? gene.synonym_name4_uc
        : null;
      this.synonym_name5 = hp.call(gene, "synonym_name5")
        ? gene.synonym_name5
        : null;
      this.synonym_name5_uc = hp.call(gene, "synonym_name5_uc")
        ? gene.synonym_name5_uc
        : null;

      this.locus_tag = hp.call(gene, "locus_tag") ? gene.locus_tag : null;
      this.old_locus_tag = hp.call(gene, "old_locus_tag")
        ? gene.old_locus_tag
        : null;
      this.old_locus_tag_uc =
        this.old_locus_tag != null ? this.old_locus_tag.toUpperCase() : null;
      this.b_number = hp.call(gene, "b_number") ? gene.b_number : null;
      this.b_number_uc =
        this.b_number != null ? this.b_number.toUpperCase() : null;
      this.product = hp.call(gene, "product") ? gene.product : null;
      this.desc = hp.call(gene, "desc") ? gene.desc : null;
      let gStats = hp.call(gene, "gene_stats") ? gene.gene_stats : null;
      this.gene_stats = {
        len: 0,
        num_a: 0,
        num_t: 0,
        num_c: 0,
        num_g: 0,
        short_seq: null
      };
      if (gStats) {
        this.gene_stats.len = hp.call(gStats, "len") ? gStats.len : 0;
        this.gene_stats.num_a = hp.call(gStats, "num_a") ? gStats.num_a : 0;
        this.gene_stats.num_t = hp.call(gStats, "num_t") ? gStats.num_t : 0;
        this.gene_stats.num_c = hp.call(gStats, "num_c") ? gStats.num_c : 0;
        this.gene_stats.num_g = hp.call(gStats, "num_g") ? gStats.num_g : 0;
        this.gene_stats.short_seq = hp.call(gStats, "short_seq")
          ? gStats.short_seq
          : null;
      }

      let gSeq = hp.call(gene, "sequence") ? gene.sequence : null;
      this.sequence = {
        type: null,
        from: 0,
        to: 0,
        comp: false,
        seq: null
      };
      if (gSeq) {
        this.sequence.type = hp.call(gSeq, "type") ? gSeq.type : null;
        this.sequence.from = hp.call(gSeq, "from") ? gSeq.from : 0;
        this.sequence.to = hp.call(gSeq, "to") ? gSeq.to : 0;
        this.sequence.comp = hp.call(gSeq, "comp") ? gSeq.comp : false;
        this.sequence.seq = hp.call(gSeq, "seq") ? gSeq.seq : null;
      }
    }
  }

  static getOlabGeneConverter() {
    // Firestore data converter
    let olabGeneConverter = {
      toFirestore: function(gene) {
        return {
          olab_id: gene.olab_id,
          name: gene.name,
          name_uc: gene.name_uc,
          synonym_name1: gene.synonym_name1,
          synonym_name1_uc: gene.synonym_name1_uc,
          synonym_name2: gene.synonym_name2,
          synonym_name2_uc: gene.synonym_name2_uc,
          synonym_name3: gene.synonym_name3,
          synonym_name3_uc: gene.synonym_name3_uc,
          synonym_name4: gene.synonym_name4,
          synonym_name4_uc: gene.synonym_name4_uc,
          synonym_name5: gene.synonym_name5,
          synonym_name5_uc: gene.synonym_name5_uc,
          locus_tag: gene.locus_tag,
          old_locus_tag: gene.old_locus_tag,
          old_locus_tag_uc: gene.old_locus_tag_uc,
          b_number: gene.b_number,
          b_number_uc: gene.b_number_uc,
          product: gene.product,
          desc: gene.desc,
          gene_stats: gene.gene_stats,
          sequence: gene.sequence
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabGene(data);
      }
    };
    return olabGeneConverter;
  }

  static getCreateGeneConverter() {
    // Firestore data converter
    let olabGeneConverter = {
      toFirestore: function(gene) {
        return {
          olab_id: gene.olab_id,
          name: gene.name,
          name_uc: gene.name_uc,
          synonym_name1: gene.synonym_name1,
          synonym_name1_uc: gene.synonym_name1_uc,
          synonym_name2: gene.synonym_name2,
          synonym_name2_uc: gene.synonym_name2_uc,
          synonym_name3: gene.synonym_name3,
          synonym_name3_uc: gene.synonym_name3_uc,
          synonym_name4: gene.synonym_name4,
          synonym_name4_uc: gene.synonym_name4_uc,
          synonym_name5: gene.synonym_name5,
          synonym_name5_uc: gene.synonym_name5_uc,
          locus_tag: gene.locus_tag,
          old_locus_tag: gene.old_locus_tag,
          old_locus_tag_uc: gene.old_locus_tag_uc,
          b_number: gene.b_number,
          b_number_uc: gene.b_number_uc,
          product: gene.product,
          desc: gene.desc,
          gene_stats: gene.gene_stats,
          sequence: gene.sequence,
          created_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabGene(data);
      }
    };
    return olabGeneConverter;
  }

  static getUpdateGeneConverter() {
    // Firestore data converter
    let olabGeneConverter = {
      toFirestore: function(gene) {
        return {
          olab_id: gene.olab_id,
          name: gene.name,
          name_uc: gene.name_uc,
          synonym_name1: gene.synonym_name1,
          synonym_name1_uc: gene.synonym_name1_uc,
          synonym_name2: gene.synonym_name2,
          synonym_name2_uc: gene.synonym_name2_uc,
          synonym_name3: gene.synonym_name3,
          synonym_name3_uc: gene.synonym_name3_uc,
          synonym_name4: gene.synonym_name4,
          synonym_name4_uc: gene.synonym_name4_uc,
          synonym_name5: gene.synonym_name5,
          synonym_name5_uc: gene.synonym_name5_uc,
          locus_tag: gene.locus_tag,
          old_locus_tag: gene.old_locus_tag,
          old_locus_tag_uc: gene.old_locus_tag_uc,
          b_number: gene.b_number,
          b_number_uc: gene.b_number_uc,
          product: gene.product,
          desc: gene.desc,
          gene_stats: gene.gene_stats,
          sequence: gene.sequence,
          updated_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabGene(data);
      }
    };
    return olabGeneConverter;
  }

  initGene() {
    OlabUtils.infoLog("OlabGene.initGene() ...");
    // Common fields: internal use
    this.olab_id = null;
    this.name_uc = null;
    this.synonym_name1_uc = null;
    this.synonym_name2_uc = null;
    this.synonym_name3_uc = null;
    this.synonym_name4_uc = null;
    this.synonym_name5_uc = null;
    this.old_locus_tag_uc = null;
    this.b_number_uc = null;

    // Common fields: User settable
    this.name = null;
    this.synonym_name1 = null;
    this.synonym_name2 = null;
    this.synonym_name3 = null;
    this.synonym_name4 = null;
    this.synonym_name5 = null;
    this.locus_tag = null;
    this.old_locus_tag = null;
    this.b_number = null;
    this.product = null;
    this.desc = null;
    this.gene_stats = null;
    this.sequence = null;
  }

  set(gene) {
    this.olab_id = gene.olab_id;
    this.name = gene.name;
    // append unique key to name_uc for search to work later
    if (this.name != null) {
      this.name_uc = this.name.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.name_uc = null;
    }
    // append unique key to synonym_nameX_uc for search to work later
    if (this.synonym_name1 != null) {
      this.synonym_name1_uc =
        this.synonym_name1.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.synonym_name1_uc = null;
    }
    if (this.synonym_name2 != null) {
      this.synonym_name2_uc =
        this.synonym_name2.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.synonym_name2_uc = null;
    }
    if (this.synonym_name3 != null) {
      this.synonym_name3_uc =
        this.synonym_name3.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.synonym_name3_uc = null;
    }
    if (this.synonym_name4 != null) {
      this.synonym_name4_uc =
        this.synonym_name4.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.synonym_name4_uc = null;
    }
    if (this.synonym_name5 != null) {
      this.synonym_name5_uc =
        this.synonym_name5.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.synonym_name5_uc = null;
    }
    this.locus_tag = gene.locus_tag;
    this.old_locus_tag = gene.old_locus_tag;
    this.old_locus_tag_uc =
      this.old_locus_tag != null ? this.old_locus_tag.toUpperCase() : null;
    this.b_number = gene.b_number;
    this.b_number_uc =
      this.b_number != null ? this.b_number.toUpperCase() : null;
    this.product = gene.product;
    this.desc = gene.desc;
    // Note: Shallow set (only set reference)
    this.gene_stats = gene.gene_stats;
    this.sequence = gene.sequence;
  }

  static infoLog(gene) {
    OlabUtils.infoLog("gene.olab_id = " + gene.olab_id);
    OlabUtils.infoLog("gene.name = " + gene.name);
    OlabUtils.infoLog("gene.name_uc = " + gene.name_uc);
    OlabUtils.infoLog("gene.synonym_name1 = " + gene.synonym_name1);
    OlabUtils.infoLog("gene.synonym_name1_uc = " + gene.synonym_name1_uc);
    OlabUtils.infoLog("gene.synonym_name2 = " + gene.synonym_name2);
    OlabUtils.infoLog("gene.synonym_name2_uc = " + gene.synonym_name2_uc);
    OlabUtils.infoLog("gene.synonym_name3 = " + gene.synonym_name3);
    OlabUtils.infoLog("gene.synonym_name3_uc = " + gene.synonym_name3_uc);
    OlabUtils.infoLog("gene.synonym_name4 = " + gene.synonym_name4);
    OlabUtils.infoLog("gene.synonym_name4_uc = " + gene.synonym_name4_uc);
    OlabUtils.infoLog("gene.synonym_name5 = " + gene.synonym_name5);
    OlabUtils.infoLog("gene.synonym_name5_uc = " + gene.synonym_name5_uc);
    OlabUtils.infoLog("gene.locus_tag = " + gene.locus_tag);
    OlabUtils.infoLog("gene.old_locus_tag = " + gene.old_locus_tag);
    OlabUtils.infoLog("gene.old_locus_tag_uc = " + gene.old_locus_tag_uc);
    OlabUtils.infoLog("gene.b_number = " + gene.b_number);
    OlabUtils.infoLog("gene.b_number_uc = " + gene.b_number_uc);
    OlabUtils.infoLog("gene.product = " + gene.product);
    OlabUtils.infoLog("gene.desc = " + gene.desc);
    OlabUtils.infoLog("gene.gene_stats = " + gene.gene_stats);

    OlabUtils.infoLog("gene.gene_stats.len = " + gene.gene_stats.len);
    OlabUtils.infoLog("gene.gene_stats.num_a = " + gene.gene_stats.num_a);
    OlabUtils.infoLog("gene.gene_stats.num_t = " + gene.gene_stats.num_t);
    OlabUtils.infoLog("gene.gene_stats.num_c = " + gene.gene_stats.num_c);
    OlabUtils.infoLog("gene.gene_stats.num_g = " + gene.gene_stats.num_g);
    OlabUtils.infoLog(
      "gene.gene_stats.short_seq = " + gene.gene_stats.short_seq
    );

    OlabUtils.infoLog("gene.sequence = " + gene.sequence);
    OlabUtils.infoLog("gene.sequence.type = " + gene.sequence.type);
    OlabUtils.infoLog("gene.sequence.from = " + gene.sequence.from);
    OlabUtils.infoLog("gene.sequence.to = " + gene.sequence.to);
    OlabUtils.infoLog("gene.sequence.comp = " + gene.sequence.comp);
    OlabUtils.infoLog("gene.sequence.seq = " + gene.sequence.seq);
  }
}

export { OlabGene };
